var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-materials-by-type',{attrs:{"typesMaterial":_vm.wrappedTypesMaterial}})
}
var staticRenderFns = []

export { render, staticRenderFns }